import { ThemeTokens, VARIANTS } from '../../types';
import {
    ACCESSIBLE_BRAND_ORANGE,
    BLACK,
    BRAND_PURPLE,
    styles as coreStyles,
    TRANSPARENT,
    WHITE,
} from './core-theme';

const EDGY_YELLOW = '#FFF58C';
const EDGY_PURPLE = '#240F4C';

const styles: Record<VARIANTS, Record<ThemeTokens, any>> = {
    ...coreStyles,
    mood_01: {
        background: {
            background: EDGY_YELLOW,
        },
        'overlay-gradient': {
            color: WHITE,
            background: EDGY_YELLOW,
        },
        ctaLink: {
            border: EDGY_PURPLE,
            color: BRAND_PURPLE,
        },
        'card-ctaLink': {
            border: ACCESSIBLE_BRAND_ORANGE,
            color: BRAND_PURPLE,
        },
        'card-text': {
            color: BRAND_PURPLE,
            underline: ACCESSIBLE_BRAND_ORANGE,
        },
        text: {
            color: BRAND_PURPLE,
            underline: EDGY_PURPLE,
        },
        card: {
            background: WHITE,
        },
        'button-primary': {
            background: EDGY_PURPLE,
            color: WHITE,
            fill: WHITE,
            border: '2px solid transparent',
            hover: {
                background: EDGY_PURPLE,
            },
            focus: {
                background: EDGY_PURPLE,
            },
            active: {
                background: EDGY_PURPLE,
            },
        },
        'button-secondary': {
            background: TRANSPARENT,
            color: BRAND_PURPLE,
            fill: BRAND_PURPLE,
            border: `2px solid ${BRAND_PURPLE}`,
            hover: {
                background: TRANSPARENT,
            },
            focus: {
                background: TRANSPARENT,
            },
            active: {
                background: TRANSPARENT,
            },
        },
        'expansion-panel-content':
            coreStyles.core_light['expansion-panel-content'],
        'expansion-panel-heading':
            coreStyles.core_light['expansion-panel-heading'],
        'expansion-panel-trigger':
            coreStyles.core_light['expansion-panel-trigger'],
        divider: coreStyles.core_light.divider,
        'text-v2': coreStyles.core_light['text-v2'],
        'background-v2': coreStyles.core_light['background-v2'],
        'video-description': coreStyles.core_light['video-description'],
        'video-headline': coreStyles.core_light['video-headline'],
        'video-tagline': coreStyles.core_light['video-tagline'],
        'interlinking-card': coreStyles.core_light['interlinking-card'],
        'ratings-module': coreStyles.core_light['ratings-module'],
    },
    mood_02: {
        background: {
            background: EDGY_PURPLE,
        },
        'overlay-gradient': {
            color: BLACK,
            background: EDGY_PURPLE,
        },
        ctaLink: {
            border: EDGY_YELLOW,
            color: WHITE,
        },
        'card-ctaLink': {
            border: ACCESSIBLE_BRAND_ORANGE,
            color: BRAND_PURPLE,
        },
        'card-text': {
            color: BRAND_PURPLE,
            underline: ACCESSIBLE_BRAND_ORANGE,
        },
        text: {
            color: WHITE,
            underline: EDGY_YELLOW,
        },
        card: {
            background: WHITE,
        },
        'button-primary': {
            background: EDGY_YELLOW,
            color: BRAND_PURPLE,
            fill: BRAND_PURPLE,
            border: '2px solid transparent',
            hover: {
                background: EDGY_YELLOW,
            },
            focus: {
                background: EDGY_YELLOW,
            },
            active: {
                background: EDGY_YELLOW,
            },
        },
        'button-secondary': {
            background: TRANSPARENT,
            color: WHITE,
            fill: WHITE,
            border: `2px solid ${WHITE}`,
            hover: {
                background: TRANSPARENT,
            },
            focus: {
                background: TRANSPARENT,
            },
            active: {
                background: TRANSPARENT,
            },
        },
        'expansion-panel-content':
            coreStyles.core_light['expansion-panel-content'],
        'expansion-panel-heading':
            coreStyles.core_light['expansion-panel-heading'],
        'expansion-panel-trigger':
            coreStyles.core_light['expansion-panel-trigger'],
        divider: coreStyles.core_light.divider,
        'text-v2': coreStyles.core_light['text-v2'],
        'background-v2': coreStyles.core_light['background-v2'],
        'video-description': coreStyles.core_light['video-description'],
        'video-headline': coreStyles.core_light['video-headline'],
        'video-tagline': coreStyles.core_light['video-tagline'],
        'interlinking-card': coreStyles.core_light['interlinking-card'],
        'ratings-module': coreStyles.core_light['ratings-module'],
    },
};

export const getThemeTokens = (token: ThemeTokens, variant: VARIANTS) => {
    return styles[variant][token];
};
